<template>
  <div>
    <Message type="info">この情報でよろしければ、保存ボタンをクリックしてください。</Message>

    <div class="confirm-panel">
      <Panel>
        <div class="confirm-item">
          <FormItemLabel label="基本設定" />
        </div>

        <div class="confirm-item">
          <div class="confirm-label">実施アカウント</div>
          <Account :name="account.name" :image="account.picture_url" :symbol="account.target_sns" />
        </div>

        <div class="confirm-item">
          <div class="confirm-label">キャンペーンタイトル</div>
          <div class="confirm-content">{{ form.title }}</div>
        </div>

        <div class="confirm-item">
          <div class="confirm-label">キャンペーン期間</div>
          <div class="confirm-content">{{ campaign_period }}</div>
        </div>
      </Panel>
    </div>

    <div class="confirm-panel">
      <Panel>
        <div class="confirm-item">
          <FormItemLabel label="応募条件" />
        </div>

        <div v-if="is_web_instantwin_campaign" class="confirm-item">
          <div class="confirm-label">キャンペーンタイプ</div>
          <div class="confirm-content">{{ campaign_type }}</div>
          <Message class="mt-x1" type="info"
            >応募ページは保存後に生成され、キャンペーン一覧画面から確認できます。</Message
          >
        </div>

        <div class="confirm-item">
          <div class="confirm-label">応募アクション</div>
          <div class="confirm-content">{{ application_type }}</div>
        </div>

        <div v-if="!is_keyword_input_hidden" class="confirm-item">
          <div class="confirm-label">以下のキャンペーンキーワード全てを含む</div>
          <Tags :value="form.keywords" :editable="false" />
        </div>

        <div v-if="is_keyword_campaign && !is_keyword_input_hidden" class="confirm-item">
          <div class="confirm-label">以下のキャンペーンキーワードいずれかを含む</div>
          <Tags v-if="form.or_keywords.length" :value="form.or_keywords" :editable="false" />
          <div v-else class="confirm-content">指定なし</div>
        </div>

        <div v-if="is_keyword_campaign && !is_keyword_input_hidden" class="confirm-item">
          <Panel>
            <span class="confirm-description">以下の組み合わせの投稿が応募対象となります。</span>
            <div v-for="(keywords, index) of combinations" :key="index" class="confirm-combination-keyword">
              <span class="confirm-combination-index">{{ index + 1 }}</span>
              <Tags :value="keywords" :editable="false" />
            </div>
          </Panel>
        </div>

        <div v-if="is_keyword_campaign && is_display_include_mention" class="confirm-item">
          <div class="confirm-label">メンションも応募対象に含める</div>
          <div class="confirm-content">{{ include_mention_text }}</div>
        </div>

        <div
          v-if="(is_keyword_campaign || is_web_instantwin_campaign) && is_display_include_reply"
          class="confirm-item"
        >
          <div class="confirm-label">返信も応募対象に含める</div>
          <div class="confirm-content">{{ include_reply_text }}</div>
        </div>

        <div v-if="is_keyword_campaign" class="confirm-item">
          <div class="confirm-label">ポジティブまたはネガティブなアカウントを判定する</div>
          <div v-if="form.is_keyword_judgment && (positive_keyword.length || negative_keyword.length)">
            <Panel>
              <div v-if="positive_keyword.length" class="confirm-judgment">
                <div v-for="(keyword, index) of positive_keyword" :key="index" class="confirm-judgment-item">
                  <Keyword type="positive" :text="keyword" />
                </div>
              </div>

              <div v-if="negative_keyword.length" class="confirm-judgment">
                <div v-for="(keyword, index) of negative_keyword" :key="index" class="confirm-judgment-item">
                  <Keyword type="warning" :text="keyword" />
                </div>
              </div>
            </Panel>
          </div>
          <div v-else class="confirm-content">OFF</div>
        </div>

        <div v-if="is_web_instantwin_campaign" class="confirm-item">
          <div class="confirm-label">フォローしていないアカウントの場合、落選にする</div>
          <div class="confirm-content">{{ form.exclude_unfollowed ? 'ON' : 'OFF' }}</div>
        </div>
        <div v-if="is_web_instantwin_campaign" class="confirm-item">
          <div class="confirm-label">懸賞アカウントの場合、落選にする</div>
          <div class="confirm-content">{{ form.exclude_hunter_account ? 'ON' : 'OFF' }}</div>
        </div>
        <div v-if="is_web_instantwin_campaign" class="confirm-item">
          <div class="confirm-label">アカウント開設日がキャンペーン期間内の場合、落選にする</div>
          <div class="confirm-content">{{ form.exclude_account_create_date_within_period ? 'ON' : 'OFF' }}</div>
        </div>
        <div v-if="is_web_instantwin_campaign" class="confirm-item">
          <div class="confirm-label">プロフィール画像が初期状態の場合、落選にする</div>
          <div class="confirm-content">{{ form.exclude_default_profile_image ? 'ON' : 'OFF' }}</div>
        </div>
        <div v-if="is_web_instantwin_campaign" class="confirm-item">
          <div class="confirm-label">自己紹介が未入力の場合、落選にする</div>
          <div class="confirm-content">{{ form.exclude_no_description ? 'ON' : 'OFF' }}</div>
        </div>
        <div v-if="is_web_instantwin_campaign" class="confirm-item">
          <div class="confirm-label">フォロワー数が指定値未満の場合、落選にする(0=制限なし)</div>
          <div class="confirm-content">{{ form.min_followers === 0 ? 'OFF' : form.min_followers }}</div>
        </div>
        <div v-if="is_web_instantwin_campaign" class="confirm-item">
          <div class="confirm-label">ポスト数が指定値未満の場合、落選にする(0=制限なし)</div>
          <div class="confirm-content">{{ form.min_tweets === 0 ? 'OFF' : form.min_tweets }}</div>
        </div>
        <div v-if="is_web_instantwin_campaign" class="confirm-item">
          <div class="confirm-label">自己紹介に次のキーワードを含む場合、落選にする。</div>
          <Tags :value="form.exclude_description_keyword" :editable="false" />
          <div
            v-if="!form.exclude_description_keyword || !form.exclude_description_keyword.length"
            class="confirm-content"
          >
            OFF
          </div>
        </div>
      </Panel>
    </div>

    <div v-if="is_long_post_notice_target" class="confirm-panel">
      <Message type="warning">
        長文ポスト時にキーワードが省略されてしまうと、応募収集が正しく行なわれません。
        <br />
        詳しくは<a href="https://help-atelu.comnico.jp/about-long-tweets" target="_blank" rel="noopener noreferrer"
          >こちら</a
        >をご確認ください。
        <div class="confirm-checkbox">
          <el-checkbox label="確認しました" v-model="is_check" />
        </div>
      </Message>
    </div>

    <div v-if="is_url_setting_notice_target" class="confirm-panel">
      <Message type="warning">
        このキャンペーンは応募収集URLの設定が必要です。
        <br />
        キャンペーン開始後、対象のキャンペーンポストのURLを設定してください。
        <br />
        設定されていない場合は応募が収集されません。詳しくは<a
          href="https://help-atelu.comnico.jp/set-campaign-post-url"
          target="_blank"
          rel="noopener noreferrer"
          >こちら</a
        >をご確認ください。
        <div class="confirm-checkbox">
          <el-checkbox label="確認しました" v-model="is_url_setting_check" />
        </div>
      </Message>
    </div>

    <div class="confirm-button">
      <el-button @click="prevStep">
        <Icon name="arrow-left" space="right" />
        戻る
      </el-button>
      <div class="confirm-button-right">
        <el-button @click="cancel">キャンセル</el-button>
        <el-button
          type="primary"
          :disabled="
            is_submit ||
            (is_long_post_notice_target && !is_check) ||
            (is_url_setting_notice_target && !is_url_setting_check)
          "
          @click="save"
          >保存</el-button
        >
      </div>
    </div>
  </div>
</template>

<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import moment from 'moment-timezone'
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import Icon from '@/client/components/_atoms/Icon.vue'
import Message from '@/client/components/_atoms/Message.vue'
import Panel from '@/client/components/_atoms/Panel.vue'
import Account from '@/client/components/_molecules/Account.vue'
import FormItemLabel from '@/client/components/_molecules/FormItemLabel.vue'
import Keyword from '@/client/components/_molecules/Keyword.vue'
import Tags from '@/client/components/_molecules/Tags.vue'
import {
  CAMPAIGN_APPLICATION_TYPES,
  CAMPAIGN_TYPES,
  TWITTER_ENTRY_ACTION_TYPES,
  WEB_INSTANTWIN_APPLICATION_TYPES
} from '@/client/constant'
import { TrackingService } from '@/client/services'
import { useCampaignDialogStore } from '@/client/store/useCampaignDialogStore'

export default defineComponent({
  name: 'CampaignCreateTwitterConfirm',
  components: {
    Account,
    FormItemLabel,
    Icon,
    Keyword,
    Message,
    Panel,
    Tags
  },
  data() {
    return {
      is_submit: false,
      is_check: false,
      is_url_setting_check: false
    }
  },
  computed: {
    ...mapState(useCampaignDialogStore, [
      'form',
      'api_accounts',
      'is_url_setting_notice_target',
      'is_keyword_input_hidden',
      'is_long_post_notice_target'
    ]),
    account() {
      const account = this.api_accounts.find(account => account.id === this.form.account_id)
      return account || { name: '', picture_url: '', target_sns: 'twitter' }
    },
    campaign_period() {
      const start_date = this.form.start_date
        ? moment(this.form.start_date).format('YYYY年MM月DD日') + ' ' + this.form.start_time
        : ''

      const end_date = this.form.end_date
        ? moment(this.form.end_date).format('YYYY年MM月DD日') + ' ' + this.form.end_time
        : ''

      return start_date + ' - ' + end_date
    },
    is_keyword_campaign() {
      return this.form.campaign_type === 'keyword'
    },
    is_web_instantwin_campaign() {
      return this.form.campaign_type === 'old_web_instantwin'
    },
    campaign_type() {
      const campaign_type_text = CAMPAIGN_TYPES.find(v => v.value === this.form.campaign_type)
      return campaign_type_text ? campaign_type_text.label : ''
    },
    application_type() {
      let application_type = ''

      switch (this.form.entry_action_type) {
        case 'retweet':
        case 'quote_tweet':
        case 'retweet_and_quote_tweet':
          application_type = 'retweet'
          break
        case 'tweet':
        case 'tweet_media':
          application_type = 'tweet'
          break
        case 'mention':
          application_type = 'mention'
          break
        case 'old_web_instantwin':
          application_type = 'old_web_instantwin'
          break
        default:
          application_type = 'instantwin'
      }

      const applicant_types = this.is_web_instantwin_campaign
        ? WEB_INSTANTWIN_APPLICATION_TYPES
        : CAMPAIGN_APPLICATION_TYPES
      const applicant_type_text = applicant_types.find(v => v.value === application_type)
      const entry_type = TWITTER_ENTRY_ACTION_TYPES.find(v => v.value === this.form.entry_action_type)
      let entry_type_text = entry_type ? entry_type.label : ''

      if (this.form.entry_action_type === 'retweet_and_quote_tweet') {
        entry_type_text = '公式リポスト&引用'
      }

      let type = applicant_type_text ? applicant_type_text.label : ''

      if (entry_type_text) {
        type += `(${entry_type_text})`
      }

      return type
    },
    combinations() {
      if (
        (!this.form.keywords || !this.form.keywords.length) &&
        (!this.form.or_keywords || !this.form.or_keywords.length)
      ) {
        return []
      }

      return this.form.or_keywords && this.form.or_keywords.length
        ? this.form.or_keywords.map(or_keyword => [...this.form.keywords, or_keyword])
        : [this.form.keywords]
    },
    is_display_include_mention() {
      return ['tweet', 'tweet_media'].includes(this.form.entry_action_type)
    },
    is_display_include_reply() {
      return ['tweet', 'tweet_media', 'mention'].includes(this.form.entry_action_type)
    },
    include_mention_text() {
      return this.form.is_include_mention ? 'ON' : 'OFF'
    },
    include_reply_text() {
      return this.form.is_include_reply ? 'ON' : 'OFF'
    },
    positive_keyword() {
      return this.form.positive_keyword || []
    },
    negative_keyword() {
      return this.form.negative_keyword || []
    }
  },
  methods: {
    ...mapActions(useCampaignDialogStore, ['createCampaign', 'prevStep']),
    cancel(payload: unknown) {
      TrackingService.sendEvent('click:キャンペーンの新規作成|確認|キャンセル')
      this.$emit('cancel', payload)
      return payload
    },
    complete(payload: unknown) {
      this.$emit('complete', payload)
      return payload
    },
    /**
     * 保存ボタン
     */
    async save() {
      TrackingService.sendEvent('click:キャンペーンの新規作成|確認|保存')

      if (this.is_submit) return

      this.is_submit = true

      const result = await this.createCampaign()

      setTimeout(() => {
        this.is_submit = false
      }, 2000)

      if (result.data && result.data.id) {
        this.complete(result.data.id)
        return
      }

      if (result.error && result.error.type === 'MAX_CAMPAIGN_COUNT_OVER') {
        this.$notify({
          title: 'キャンペーンの作成に失敗しました。',
          message: '同時開催可能件数を超えるため、指定の期間ではキャンペーンを開催できません。',
          customClass: 'danger'
        })
        return
      }

      if (result.error && result.error.type === 'CAMPAIGN_START_DATETIME_INVALID') {
        this.$notify({
          title: 'キャンペーンの作成に失敗しました。',
          message: 'キャンペーン開始日時は、現在日時より後を指定してください。',
          customClass: 'danger'
        })
        return
      }

      return this.$notify({
        title: 'キャンペーンの作成に失敗しました。',
        message: '恐れ入りますが、時間をおいて再度お試しください。',
        customClass: 'danger'
      })
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'sass:math';
@use '@/client/assets/scss/variables.scss' as *;

.confirm-panel {
  margin-top: $spacing-unit * 2;

  .confirm-item {
    &:not(:last-child) {
      margin-bottom: $spacing-unit * 3;
    }

    .confirm-label {
      margin-bottom: $spacing-unit;
    }

    .confirm-content {
      font-size: $font-large-size;
    }

    .confirm-description {
      font-size: $font-small-size;
      color: $sub-text-color;
    }

    .confirm-combination-keyword {
      display: flex;
      align-items: center;
      margin-top: $spacing-unit;

      .confirm-combination-index {
        margin-right: $spacing-unit;
        margin-bottom: $spacing-unit;
      }
    }

    .confirm-judgment {
      display: flex;
      flex-flow: wrap;

      .confirm-judgment-item {
        margin: math.div($spacing-unit, 2);

        .confirm-judgment-icon-positive {
          color: $primary-color;
        }

        .confirm-judgment-icon-negative {
          color: $warning-color;
        }
      }
    }
  }
}

.confirm-button {
  display: flex;
  justify-content: space-between;
  margin-top: $spacing-unit * 3;
}

.confirm-checkbox {
  margin-top: $spacing-unit;

  :deep(.el-checkbox) {
    box-shadow: unset;
  }

  :deep(.el-checkbox__input.is-checked + .el-checkbox__label) {
    color: $text-color;
  }
}
</style>
